import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as tz from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(tz);
// example value of utcDate 2023-05-25T23:00:00.000Z
export function utcToLocalConversion(
  utcDate: string,
  timeZone = 'Asia/Kolkata'
): string {
  const localDate = dayjs(utcDate)
    .local()
    .tz(timeZone)
    .format('YYYY-MM-DDTHH:mm:ss.sss');
  return `${localDate}Z`;
}
